import type { CSSProperties } from 'react';

// Shared modal chrome for the AR modals (Create Invoice + Record Receipt).
// Extracted verbatim from the inline constants that lived in ar.tsx so both the
// route-owned CreateInvoiceModal and the moved RecordReceiptModal render with
// identical chrome. Plain inline CSSProperties — no tailwind.

export const modalOverlay: CSSProperties = {
  position: 'fixed',
  inset: 0,
  background: 'rgba(15,15,20,0.45)',
  display: 'grid',
  placeItems: 'center',
  zIndex: 150,
  padding: 24,
};

export const modalBox: CSSProperties = {
  background: 'white',
  borderRadius: 12,
  width: 760,
  maxWidth: '100%',
  boxShadow: '0 28px 80px rgba(0,0,0,0.18)',
  overflow: 'hidden',
};

export const modalHeader: CSSProperties = {
  padding: '18px 22px',
  borderBottom: '1px solid var(--border)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
};

export const modalTitle: CSSProperties = {
  margin: 0,
  fontSize: 18,
  fontWeight: 600,
  fontFamily: 'var(--font-display)',
};

export const modalBody: CSSProperties = {
  padding: '22px',
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
  maxHeight: '70vh',
  overflowY: 'auto',
};

export const modalFooter: CSSProperties = {
  padding: '14px 22px',
  borderTop: '1px solid var(--border)',
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 8,
  background: '#fafafa',
};

export const modalLabel: CSSProperties = {
  fontSize: 14,
  color: 'var(--text-muted)',
  fontWeight: 500,
  display: 'block',
  marginBottom: 6,
};

export const modalError: CSSProperties = {
  color: 'var(--negative)',
  fontSize: 14,
  marginTop: 8,
};
